import { Component, ViewChild } from '@angular/core';

import { TableComponent } from '@shared/components/table/table.component';
import { LabelDirective } from '@shared/components/input/label/label.directive';
import { TableConfig } from '@shared/interfaces/table/table-config';
import { DashboardQueryMeteredDataLockResultDto } from '@app/api/dmc';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { HeaderService } from '@app/core/services/header.service';
import { lockedMeteredDataTable } from '@shared/table-configs/dashboard/locked-metered-data.table';
import { TranslatePipe } from '@ngx-translate/core';
import { InputGroupComponent } from '@shared/components/input/input-group/input-group.component';
import { CardComponent } from '@shared/components/card/card.component';
import { ButtonDirective } from '@shared/components/input/button/button.directive';
import { InputDirective } from '@shared/components/input/input/input.directive';
import { Observable } from 'rxjs';
import { ModalService } from '@app/core/services/modal.service';
import { RemoveLockComponent } from '@shared/modals/timeseries/remove-lock/remove-lock.component';
import { SortParam } from '@app/core/constants/sort-param';
import { ODataService } from '@app/core/services/odata/odata.service';
import { InputDateDirective } from '@shared/components/input/date/input-date.directive';

@Component({
  selector: 'app-dashboard-timeseries-locked',
  imports: [
    TableComponent,
    CardComponent,
    LabelDirective,
    TranslatePipe,
    InputGroupComponent,
    ReactiveFormsModule,
    ButtonDirective,
    InputDirective,
    InputDateDirective
  ],
  templateUrl: './dashboard-timeseries-locked.component.html',
  styleUrls: ['./dashboard-timeseries-locked.component.css'],
})
export class DashboardTimeseriesLockedComponent {
  @ViewChild('table', { static: false }) public table?: TableComponent<any>;

  /** Table **/
  public lockedTimeseriesTableConfig: TableConfig<DashboardQueryMeteredDataLockResultDto> = {
    id: 'dashboard-locked-timeseries-table',
    oData: true,
    ...lockedMeteredDataTable,
    serviceCallback: (pageSize: number, page: number, sort?: SortParam) => this.search(pageSize, page, sort),
  };

  /** Selected Table Element */
  public selectedElements: DashboardQueryMeteredDataLockResultDto[] = [];

  /** Search Form **/
  public searchForm: FormGroup = new FormGroup({
    occurrence: new FormControl(),
    meteringPointIdentification: new FormControl(),
  });

  constructor(
    private readonly headerService: HeaderService,
    private readonly modalService: ModalService,
    private readonly oDataService: ODataService,
  ) {
    this.headerService.setTitle('dashboard.lockedtimeseries.title');
    this.headerService.setActions([
        {
          id: 'removeLock',
          title: 'dashboard.lockedtimeseries.removelock.action',
          callback: () => this.openRemoveLockModal(),
          disabled: () => this.selectedElements.length === 0,
        }
      ]
    )
  }

  public search(pageSize: number, page: number, sort?: SortParam): Observable<any> {
    const formValues = this.searchForm.getRawValue();

    const filter = this.oDataService.filter();

    // Handle date-only fields
    if (formValues.occurrence) {
      filter.dateOnly('occurrence', new Date(formValues.occurrence));
    }

    // Handle other fields normally
    if (formValues.meteringPointIdentification) {
      filter.equals('meteringPointIdentification', formValues.meteringPointIdentification);
    }

    return this.oDataService.dmc.getPaginated(
      'MeteredDataLock',
      { page, pageSize, sort },
      filter
    );
  }


  public openRemoveLockModal(): void {
    this.modalService.show({
      component: RemoveLockComponent,
      title: 'dashboard.lockedtimeseries.removelock.title',
      type: 'middle',
      actions: [
        { type: 'primary', label: 'common.remove', method: 'submit' },
        { type: 'secondary', label: 'system.button.cancel', closeOnClick: true },
      ],
      params: {
        element: this.selectedElements,
      }
    }).subscribe(() => {
      this.table?.search();
    })
  }


}
